import * as React from 'react';

import Icon from 'components/atoms/Icon';

export type CtaWaveProps = {
	text: string;
	icon?: string;
	onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

const CtaWave = ({ icon, text, onClick }: CtaWaveProps) => {
	return (
		<a className="a-cta-wave" href="/" onClick={onClick}>
			{icon && (
				<div className="a-cta-wave__icon">
					<Icon iconName={icon} />
				</div>
			)}
			<div className="a-cta-wave__circle a-cta-wave__circle--size-s" />
			<div className="a-cta-wave__circle a-cta-wave__circle--size-m" />
			<div className="a-cta-wave__circle a-cta-wave__circle--size-l" />
			<span className="a-cta-wave__text">{text}</span>
		</a>
	);
};

export default CtaWave;
